import { VueGtag } from 'vue-gtag';
import { Router } from 'vue-router';
import api from '@/api';
import { resetAccessGuardCache } from '@/routers-capability/accessGuard';
import store from '@/stores/pcStore';
import { forcedIdeationTemporalStorage } from '@/components/forced-ideation/utils/temporal-storage';
import { clearSavedInsightDetailsPagination } from '@/components/insights/saved/use-saved-insights-pagination';
import { clearConfirmedInsightSavedStates } from '@/components/insights/use-insight-save-toggle';
import { isDynamicImportError } from '@/utils/dynamicImportError';
import { clearLastUsedAgent } from '@/utils/lastUsedAgent';
import { clearSWRVCache } from './swr';
import { userSession } from './userSession';

// ルーターガードがログインし直しが必要と判断したときは、ログアウトAPIを呼ばずにこれだけを使う
export const clearLocalSession = (gtag: VueGtag): void => {
  userSession.clear(gtag);
  // userSession.clear は localStorage のみ消すため、sessionStorage の退避は個別にクリアする
  forcedIdeationTemporalStorage.clear();
  clearSWRVCache();
  resetAccessGuardCache();
  clearLastUsedAgent();
  clearSavedInsightDetailsPagination();
  clearConfirmedInsightSavedStates();
  store.commit('resetState');
};

export default async function signout(
  gtag: VueGtag,
  router: Router,
  redirectPath: string | undefined = undefined,
) {
  clearLocalSession(gtag);
  let redirectError: unknown;
  try {
    await api.signout();
  } finally {
    // セッション切れでログアウト処理になる場合、
    // api.signout()が401エラーになるので
    // finallyの中でログインページへの遷移を行う
    // (no-unsafe-finally対応のため、再スローはfinally節の外で行う)
    try {
      await router.push({
        name: 'login',
        query: {
          redirect: redirectPath,
        },
      });
    } catch (error) {
      redirectError = error;
    }
  }

  // 動的インポート失敗（ANDEV-9612/ANDEV-9662）はrouter.onErrorが検知して
  // リロード復帰させるため、ここでの再スローは不要な重複エラーを生むだけになる
  if (redirectError && !isDynamicImportError(redirectError)) {
    throw redirectError;
  }
}
